const initialState = {
  user: null,
  isLoggedIn: false
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case "USER_LOGIN":
      return { ...state, user: action.value, isLoggedIn: true };
    case "USER_LOGOUT":
      return { ...state, user: action.value, isLoggedIn: false };
    default:
      return state;
  }
}
